"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@apollo/client/core");
var cancelVehicleReservationMutation = {
    CANCEL_VEHICLE_RESERVATION: core_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation CancelVehicleReservation($dealId: String!) {\n      cancelVehicleReservation(dealId: $dealId)\n    }\n  "], ["\n    mutation CancelVehicleReservation($dealId: String!) {\n      cancelVehicleReservation(dealId: $dealId)\n    }\n  "]))),
};
exports.default = cancelVehicleReservationMutation;
var templateObject_1;
